import type React from "react";
import { useChannels } from "@/hooks/channel/useChannels";
import { NavLink } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Hash, Megaphone } from "lucide-react";
import { cn } from "@/libs/utils";

export const ChannelList: React.FC = () => {
	const { channels, loading, error } = useChannels();

	if (loading) {
		return (
			<div className="space-y-2 px-2">
				{Array.from({ length: 4 }, () => crypto.randomUUID()).map((id) => (
					<Skeleton key={id} className="h-8 w-full" />
				))}
			</div>
		);
	}

	if (error) {
		return (
			<Alert variant="destructive" className="mx-2">
				<AlertDescription>
					チャンネル一覧の取得に失敗しました。
				</AlertDescription>
			</Alert>
		);
	}

	return (
		<nav className="space-y-1 px-2">
			{channels?.map((channel) => (
				<NavLink
					key={channel.id}
					to={`/webapp/channels/${channel.id}`}
					className={({ isActive }) =>
						cn(
							"flex items-center space-x-2 px-2 py-1.5 rounded-md text-sm font-medium",
							"hover:bg-gray-100 dark:hover:bg-gray-800",
							"transition-colors duration-200",
							isActive
								? "bg-gray-100 dark:bg-gray-800 text-primary"
								: "text-gray-600 dark:text-gray-400",
						)
					}
				>
					{channel.type === "ANNOUNCEMENT" ? (
						<Megaphone className="h-4 w-4" />
					) : (
						<Hash className="h-4 w-4" />
					)}
					<span>{channel.name}</span>
				</NavLink>
			))}
		</nav>
	);
};
